@if (data(); as msg) {
 <span>{{msg.name}} already exists.</span>
}
 